export const EMPLOYEE_QUERY_KEY = 'employeeIntegration';

export interface SlackEmployeeIntegration {
  active: boolean;
  slackTeamId: string;
  slackUserId: string;
}

export interface GoogleEmployeeIntegration {
  active: boolean;
}

export interface MicrosoftEmployeeIntegration {
  active: boolean;
}

export interface GreenhouseOAuthEmployeeIntegration {
  active: boolean;
  needs_reauth?: boolean;
}
